import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 28, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, tone = "lav" }) {
  const tones = {
    lav: "text-lav-deep bg-lav-soft",
    mint: "text-mint-deep bg-mint-soft",
    blush: "text-blush-deep bg-blush-soft",
  };
  return (
    <span className={`inline-block rounded-full px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.2em] ${tones[tone]}`}>
      {children}
    </span>
  );
}
